






























import { Component, Vue } from "vue-property-decorator";
import TabBar from "@/components/TabBar/TabBar.vue";
import TabBarItem from "@/components/TabBar/TabBarItem.vue";
import OrderCompleted from "@/components/OrderCompleted/OrderCompleted.vue";
import Event_bus from "@/utils/event_bus";

@Component({
  components: {
    TabBarItem,
    TabBar,
    FreeFollow: () => import("@/components/FreeFollow/FreeFollow.vue"),
    RecommendOffer: () =>
      import("@/components/RecommendOffer/RecommendOffer.vue"),
    OrderCompleted
  },
  name: "Home"
})
export default class Home extends Vue {
  private orderCompleted: any = {
    show: false,
    data: {}
  };
  private isShowFreeFollow = false;
  private launchRecommendOffer: any = {
    show: false,
    offer: {}
  };

  private tabBarList: any = [
    {
      activeIcon: "icon-tab_follower_sel",
      icon: "icon-tab_follower_un",
      link: "Followers"
    },
    {
      activeIcon: "icon-tab_like_sel",
      icon: "icon-tab_like_un",
      link: "Likes"
    },
    {
      activeIcon: "icon-tab_coin_sel",
      icon: "icon-tab_coin_un",
      link: "Earns"
    },
    {
      activeIcon: "icon-tab_store_sel",
      icon: "icon-tab_store_un",
      link: "Coins"
    },
    {
      activeIcon: "icon-tab_more_sel",
      icon: "icon-tab_more_un",
      link: "More"
    }
  ];

  set activeIndex(value: any) {
    //
  }

  get activeIndex() {
    return this.tabBarList.findIndex((v: any) => {
      return this.$route.path.indexOf(v.link) > -1;
    });
  }

  private mounted() {
    Event_bus.$on("show_launch_recommend", (val: any) => {
      this.launchRecommendOffer = val;
    });

    Event_bus.$on("show_order_completed", (val: any) => {
      console.log("orderCompleted", val);
      this.orderCompleted = val;
    });

    Event_bus.$on("is_show_free_follow", (val: any) => {
      this.isShowFreeFollow = val;
    });
  }
}
